import {
  RenewalMobileMenu,
  Typography,
  UnregisterBattery,
  RenewalWebMenuItem,
} from '@thingsw/pitta-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles, Theme } from '@material-ui/core/styles';

import {
  ENABLED_CLOUD_OLD_MODELS,
  ICameraInfo,
  PermissionProps,
  SemanticDarkColors,
} from '@thingsw/pitta-modules';
import { useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { THEME } from '../../features/Theme/slice';
import { APP_MENU } from '../../screens/app/renewal2/RenewalMapviewScreen';
import _ from 'lodash';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    // display: "block",
    // fill: LightColors.secondary["11"],
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
  },
  delete: {
    color: (props: any) => props.colors.secondary['11'],
  },
  deleteIcon: {
    display: 'block',
    fill: (props: any) => props.colors.primary['1'],
  },

  newDiv: {
    backgroundColor: (props: any) => props.colors.secondary['11'],
    borderRadius: 12,
    width: 43,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  papperRoot: {
    backgroundColor: (props: any) =>
      props.color === 'dark' ? SemanticDarkColors.primary['1'] : 'white',
  },
}));

interface RenewalMobileCameraMenuProps {
  open: boolean;
  camera?: ICameraInfo;
  newFw?: boolean;
  onClose: () => void;
  onClickMenu: (nemu: APP_MENU) => void;
}

export const RenewalMobileCameraMenu = ({
  open,
  camera,
  newFw,
  onClose,
  onClickMenu,
  ...restProps
}: RenewalMobileCameraMenuProps & PermissionProps) => {
  const { colors, color } = useSelector((state: RootState) => state[THEME]);

  const classes = useStyles({ color, colors });
  const { t } = useTranslation();
  const {
    settingsCamPerm,
    renameCamPerm,
    deleteCamPerm,
    fotaCamPerm,
    rebootCamPerm,
  } = restProps;

  // mantis - 12676, 클라우드 등록되었고, 서버와 통신이력 X / 카메라알기위함 (Leehj)
  // const loggined = useMemo(() => {
  //   if (camera) {
  //     return !camera.login_date
  //       ? false
  //       : !moment(camera.login_date).isBefore(moment.utc(0));
  //   }
  // }, [camera]);

  return (
    <RenewalMobileMenu
      open={open}
      onClose={onClose}
      title={camera?.dev_name ?? ''}
      colors={colors}
      paperClasses={classes.papperRoot}
    >
      {camera?.reg_category === 'cloud' && [
        <RenewalWebMenuItem
          key='cloud-menu-1'
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.7007 5.60156C20.5509 5.60156 22.0508 7.10144 22.0508 8.95162V12.3519C22.0508 14.2021 20.5509 15.702 18.7007 15.702H13.602V14.102H18.7007C19.6673 14.102 20.4508 13.3184 20.4508 12.3519V8.95162C20.4508 7.98509 19.6673 7.20156 18.7007 7.20156H6.80084C5.83431 7.20156 5.05078 7.98509 5.05078 8.95162V9.8009H3.45078V8.95162C3.45078 7.10144 4.95065 5.60156 6.80084 5.60156H18.7007Z'
                fill={colors.primary['1']}
              />
              <path
                d='M5.63283 3H9.03279C9.50225 3 9.88281 3.38059 9.88281 3.85004C9.88281 4.3195 9.50225 4.70008 9.03279 4.70008H5.63283C5.16338 4.70008 4.78281 4.3195 4.78281 3.85004C4.78281 3.38059 5.16338 3 5.63283 3Z'
                fill={colors.primary['1']}
              />
              <path
                d='M15.3445 12.2644C14.429 12.2644 13.687 11.5223 13.687 10.6068C13.687 9.69134 14.429 8.94922 15.3445 8.94922C16.2599 8.94922 17.002 9.69134 17.002 10.6068C17.002 11.5223 16.2599 12.2644 15.3445 12.2644Z'
                stroke={colors.primary['1']}
                strokeWidth='1.70004'
              />
              <path
                d='M4.2371 17.5899C3.79331 17.4368 3.40234 17.8313 3.40234 18.3007V19.1508C3.40234 19.6203 3.78291 20.0008 4.25236 20.0008H5.10232C5.57178 20.0008 5.96631 19.6099 5.81322 19.1661C5.5586 18.4279 4.97525 17.8445 4.2371 17.5899ZM4.24986 14.1103C3.78508 14.0442 3.40234 14.4311 3.40234 14.9006C3.40234 15.3701 3.78675 15.7418 4.24692 15.8347C5.9158 16.1716 7.23142 17.4873 7.56832 19.1563C7.66121 19.6164 8.0329 20.0008 8.50234 20.0008C8.97179 20.0008 9.35872 19.6181 9.29263 19.1533C8.92143 16.5429 6.86021 14.4815 4.24986 14.1103ZM4.25172 10.6885C3.78417 10.6463 3.40234 11.031 3.40234 11.5004C3.40234 11.9699 3.78438 12.3455 4.251 12.397C7.7976 12.7886 10.6143 15.6054 11.0058 19.1522C11.0573 19.6188 11.4329 20.0008 11.9023 20.0008C12.3718 20.0008 12.7564 19.619 12.7143 19.1515C12.3103 14.6622 8.73465 11.0924 4.25172 10.6885Z'
                fill={colors.primary['1']}
              />
            </svg>
          }
          darkMode={color === 'dark'}
          colors={colors}
          onClick={() => onClickMenu('CONNECT_DASHCAM_LOCALLY')}
        >
          {t('Connect Dashcam Locally (Wi-Fi)')}
        </RenewalWebMenuItem>,

        <RenewalWebMenuItem
          key='cloud-menu-2'
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.73226 10.1435L5.06966 10.0064L5.18785 9.66198C6.15883 6.83213 8.84316 4.8 12 4.8C15.7464 4.8 18.8254 7.66207 19.1682 11.3185L19.2164 11.8323L19.7044 12.0003C21.1576 12.5002 22.2 13.8794 22.2 15.5C22.2 16.4328 21.7929 17.3733 21.1547 18.0842C20.5108 18.8015 19.7125 19.2 19 19.2H7H6.99998H6.99996H6.99992H6.99988H6.99982H6.99976H6.99969H6.9996H6.99951H6.99941H6.9993H6.99918H6.99905H6.99891H6.99876H6.9986H6.99843H6.99826H6.99807H6.99788H6.99767H6.99746H6.99723H6.997H6.99676H6.99651H6.99625H6.99599H6.99571H6.99543H6.99513H6.99483H6.99452H6.9942H6.99387H6.99353H6.99319H6.99283H6.99247H6.9921H6.99172H6.99133H6.99094H6.99053H6.99012H6.9897H6.98927H6.98883H6.98838H6.98793H6.98747H6.987H6.98652H6.98603H6.98554H6.98504H6.98453H6.98401H6.98349H6.98295H6.98241H6.98186H6.98131H6.98074H6.98017H6.97959H6.97901H6.97841H6.97781H6.9772H6.97659H6.97597H6.97533H6.9747H6.97405H6.9734H6.97274H6.97207H6.9714H6.97072H6.97003H6.96934H6.96864H6.96793H6.96721H6.96649H6.96576H6.96503H6.96428H6.96353H6.96278H6.96202H6.96125H6.96047H6.95969H6.9589H6.95811H6.95731H6.9565H6.95568H6.95486H6.95404H6.95321H6.95237H6.95152H6.95067H6.94981H6.94895H6.94808H6.94721H6.94632H6.94544H6.94454H6.94365H6.94274H6.94183H6.94091H6.93999H6.93907H6.93813H6.93719H6.93625H6.9353H6.93434H6.93338H6.93242H6.93145H6.93047H6.92949H6.9285H6.92751H6.92651H6.92551H6.9245H6.92349H6.92247H6.92145H6.92042H6.91939H6.91835H6.9173H6.91626H6.91521H6.91415H6.91309H6.91202H6.91095H6.90987H6.90879H6.90771H6.90662H6.90552H6.90443H6.90332H6.90222H6.9011H6.89999H6.89887H6.89774H6.89661H6.89548H6.89435H6.8932H6.89206H6.89091H6.88976H6.8886H6.88744H6.88628H6.88511H6.88393H6.88276H6.88158H6.88039H6.87921H6.87802H6.87682H6.87562H6.87442H6.87322H6.87201H6.8708H6.86958H6.86836H6.86714H6.86592H6.86469H6.86346H6.86222H6.86099H6.85974H6.8585H6.85725H6.856H6.85475H6.8535H6.85224H6.85097H6.84971H6.84844H6.84717H6.8459H6.84463H6.84335H6.84207H6.84078H6.8395H6.83821H6.83692H6.83563H6.83433H6.83303H6.83173H6.83043H6.82913H6.82782H6.82651H6.8252H6.82389H6.82257H6.82126H6.81994H6.81862H6.81729H6.81597H6.81464H6.81331H6.81198H6.81065H6.80932H6.80798H6.80665H6.80531H6.80397H6.80263H6.80128H6.79994H6.79859H6.79724H6.7959H6.79454H6.79319H6.79184H6.79049H6.78913H6.78778H6.78642H6.78506H6.7837H6.78234H6.78098H6.77962H6.77825H6.77689H6.77553H6.77416H6.77279H6.77143H6.77006H6.76869H6.76732H6.76595H6.76458H6.76321H6.76184H6.76047H6.7591H6.75773H6.75635H6.75498H6.75361H6.75223H6.75086H6.74949H6.74811H6.74674H6.74537H6.74399H6.74262H6.74125H6.73987H6.7385H6.73713H6.73575H6.73438H6.73301H6.73164H6.73027H6.72889H6.72752H6.72615H6.72478H6.72341H6.72204H6.72068H6.71931H6.71794H6.71658H6.71521H6.71385H6.71248H6.71112H6.70976H6.7084H6.70704H6.70568H6.70432H6.70296H6.70161H6.70025H6.6989H6.69755H6.69619H6.69484H6.6935H6.69215H6.6908H6.68946H6.68812H6.68677H6.68543H6.6841H6.68276H6.68142H6.68009H6.67876H6.67743H6.6761H6.67478H6.67345H6.67213H6.67081H6.66949H6.66817H6.66686H6.66554H6.66423H6.66293H6.66162H6.66032H6.65901H6.65772H6.65642H6.65512H6.65383H6.65254H6.65125H6.64997H6.64869H6.64741H6.64613H6.64485H6.64358H6.64231H6.64105H6.63978H6.63852H6.63726H6.63601H6.63476H6.63351H6.63226H6.63102H6.62978H6.62854H6.62731H6.62607H6.62485H6.62362H6.6224H6.62118H6.61997H6.61876H6.61755H6.61635H6.61515H6.61395H6.61275H6.61156H6.61038H6.6092H6.60802H6.60684H6.60567H6.6045H6.60334H6.60218H6.60102H6.59987H6.59872H6.59758H6.59644H6.5953H6.59417H6.59304H6.59192H6.5908H6.58968H6.58857H6.58747H6.58637H6.58527H6.58418H6.58309H6.582H6.58092H6.57985H6.57878H6.57771H6.57665H6.5756H6.57454H6.5735H6.57246H6.57142H6.57039H6.56936H6.56834H6.56732H6.56631H6.5653H6.5643H6.5633H6.56231H6.56133H6.56035H6.55937H6.5584H6.55743H6.55648H6.55552H6.55457H6.55363H6.55269H6.55176H6.55083H6.54991H6.549H6.54809H6.54719H6.54629H6.5454H6.54451H6.54363H6.54276H6.54189H6.54103H6.54017H6.53932H6.53848H6.53764H6.53681H6.53598H6.53516H6.53435H6.53355H6.53275H6.53195H6.53117H6.53039H6.52961H6.52884H6.52808H6.52733H6.52658H6.52584H6.52511H6.52438H6.52366H6.52294H6.52224H6.52154H6.52084H6.52016H6.51948H6.51881H6.51814H6.51748H6.51683H6.51619H6.51555H6.51492H6.5143H6.51369H6.51308H6.51248H6.51189H6.5113H6.51073H6.51016H6.50959H6.50904H6.50849H6.50795H6.50742H6.5069H6.50638H6.50588H6.50538H6.50488H6.5044H6.50392H6.50345H6.50299H6.50254H6.5021H6.50166H6.50123H6.50081H6.5004H6.5C3.90429 19.2 1.8 17.0957 1.8 14.5C1.8 12.5309 3.0112 10.8427 4.73226 10.1435Z'
                stroke={colors.primary['1']}
                strokeWidth='1.6'
              />
              <path
                d='M9 12.6667L12.6667 9M12.6667 9H10.8333M12.6667 9V10.8333M10.8333 14.5V16.3333M10.8333 16.3333H12.6667M10.8333 16.3333L14.5 12.6667'
                stroke={colors.primary['1']}
                strokeWidth='1.4'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          }
          colors={colors}
          darkMode={color === 'dark'}
          onClick={() => onClickMenu('CLOUD_CONNECTION_SETTING')}
        >
          {t('Cloud Connection Setting')}
        </RenewalWebMenuItem>,
      ]}
      <RenewalWebMenuItem
        disabled={!renameCamPerm || camera?.valid === 'invalid'}
        startIcon={
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M5 7H19C20.6569 7 22 8.34315 22 10V14C22 15.6569 20.6569 17 19 17H5C3.34314 17 2 15.6569 2 14V10C2 8.34315 3.34314 7 5 7Z'
              stroke={colors.primary['1']}
              strokeWidth='1.6'
            />
            <path
              d='M15.05 13.9C13.973 13.9 13.1 13.027 13.1 11.95C13.1 10.873 13.973 10 15.05 10C16.127 10 17 10.873 17 11.95C17 13.027 16.127 13.9 15.05 13.9Z'
              stroke={colors.primary['1']}
              strokeWidth='2'
            />
            <path
              d='M4 4L8 4'
              stroke={colors.primary['1']}
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        }
        colors={colors}
        darkMode={color === 'dark'}
        onClick={() => onClickMenu('CAMERA_PROFILE')}
      >
        {t('Camera Profile')}
      </RenewalWebMenuItem>

      {settingsCamPerm && (
        <RenewalWebMenuItem
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_7650_62225)'>
                <path
                  d='M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z'
                  stroke={colors.primary['1']}
                  strokeWidth='1.6'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M18.1673 14.5007C18.0564 14.752 18.0233 15.0308 18.0723 15.3011C18.1213 15.5715 18.2502 15.8209 18.4423 16.0173L18.4923 16.0673C18.6473 16.2221 18.7702 16.4059 18.8541 16.6083C18.938 16.8106 18.9811 17.0275 18.9811 17.2465C18.9811 17.4655 18.938 17.6824 18.8541 17.8847C18.7702 18.087 18.6473 18.2709 18.4923 18.4257C18.3375 18.5806 18.1537 18.7035 17.9514 18.7874C17.7491 18.8713 17.5322 18.9145 17.3132 18.9145C17.0941 18.9145 16.8772 18.8713 16.6749 18.7874C16.4726 18.7035 16.2888 18.5806 16.134 18.4257L16.084 18.3757C15.8876 18.1835 15.6381 18.0547 15.3678 18.0056C15.0975 17.9566 14.8187 17.9897 14.5673 18.1007C14.3208 18.2063 14.1106 18.3817 13.9626 18.6053C13.8145 18.8288 13.7351 19.0908 13.734 19.359V19.5007C13.734 19.9427 13.5584 20.3666 13.2458 20.6792C12.9333 20.9917 12.5093 21.1673 12.0673 21.1673C11.6253 21.1673 11.2014 20.9917 10.8888 20.6792C10.5762 20.3666 10.4007 19.9427 10.4007 19.5007V19.4257C10.3942 19.1498 10.3049 18.8823 10.1444 18.6579C9.9839 18.4335 9.7596 18.2626 9.50065 18.1673C9.2493 18.0564 8.97049 18.0233 8.70016 18.0723C8.42983 18.1213 8.18038 18.2502 7.98398 18.4423L7.93398 18.4923C7.7792 18.6473 7.59538 18.7702 7.39305 18.8541C7.19072 18.938 6.97384 18.9811 6.75482 18.9811C6.53579 18.9811 6.31891 18.938 6.11658 18.8541C5.91425 18.7702 5.73044 18.6473 5.57565 18.4923C5.42069 18.3375 5.29776 18.1537 5.21388 17.9514C5.13001 17.7491 5.08684 17.5322 5.08684 17.3132C5.08684 17.0941 5.13001 16.8772 5.21388 16.6749C5.29776 16.4726 5.42069 16.2888 5.57565 16.134L5.62565 16.084C5.81777 15.8876 5.94664 15.6381 5.99565 15.3678C6.04467 15.0975 6.01158 14.8187 5.90065 14.5673C5.79502 14.3208 5.61961 14.1106 5.39604 13.9626C5.17246 13.8145 4.91047 13.7351 4.64232 13.734H4.50065C4.05862 13.734 3.6347 13.5584 3.32214 13.2458C3.00958 12.9333 2.83398 12.5093 2.83398 12.0673C2.83398 11.6253 3.00958 11.2014 3.32214 10.8888C3.6347 10.5762 4.05862 10.4007 4.50065 10.4007H4.57565C4.85148 10.3942 5.11899 10.3049 5.3434 10.1444C5.56781 9.9839 5.73875 9.7596 5.83398 9.50065C5.94491 9.2493 5.978 8.97049 5.92899 8.70016C5.87997 8.42983 5.7511 8.18038 5.55898 7.98398L5.50898 7.93398C5.35402 7.7792 5.23109 7.59538 5.14722 7.39305C5.06334 7.19072 5.02017 6.97384 5.02017 6.75482C5.02017 6.53579 5.06334 6.31891 5.14722 6.11658C5.23109 5.91425 5.35402 5.73044 5.50898 5.57565C5.66377 5.42069 5.84759 5.29776 6.04992 5.21388C6.25225 5.13001 6.46913 5.08684 6.68815 5.08684C6.90718 5.08684 7.12405 5.13001 7.32639 5.21388C7.52872 5.29776 7.71253 5.42069 7.86732 5.57565L7.91732 5.62565C8.11372 5.81777 8.36316 5.94664 8.63349 5.99565C8.90382 6.04467 9.18264 6.01158 9.43398 5.90065H9.50065C9.74713 5.79502 9.95733 5.61961 10.1054 5.39604C10.2535 5.17246 10.3329 4.91047 10.334 4.64232V4.50065C10.334 4.05862 10.5096 3.6347 10.8221 3.32214C11.1347 3.00958 11.5586 2.83398 12.0007 2.83398C12.4427 2.83398 12.8666 3.00958 13.1792 3.32214C13.4917 3.6347 13.6673 4.05862 13.6673 4.50065V4.57565C13.6684 4.84381 13.7478 5.1058 13.8959 5.32937C14.044 5.55295 14.2542 5.72835 14.5007 5.83398C14.752 5.94491 15.0308 5.978 15.3011 5.92899C15.5715 5.87997 15.8209 5.7511 16.0173 5.55898L16.0673 5.50898C16.2221 5.35402 16.4059 5.23109 16.6083 5.14722C16.8106 5.06334 17.0275 5.02017 17.2465 5.02017C17.4655 5.02017 17.6824 5.06334 17.8847 5.14722C18.087 5.23109 18.2709 5.35402 18.4257 5.50898C18.5806 5.66377 18.7035 5.84759 18.7874 6.04992C18.8713 6.25225 18.9145 6.46913 18.9145 6.68815C18.9145 6.90718 18.8713 7.12405 18.7874 7.32639C18.7035 7.52872 18.5806 7.71253 18.4257 7.86732L18.3757 7.91732C18.1835 8.11372 18.0547 8.36316 18.0056 8.63349C17.9566 8.90382 17.9897 9.18264 18.1007 9.43398V9.50065C18.2063 9.74713 18.3817 9.95733 18.6053 10.1054C18.8288 10.2535 19.0908 10.3329 19.359 10.334H19.5007C19.9427 10.334 20.3666 10.5096 20.6792 10.8221C20.9917 11.1347 21.1673 11.5586 21.1673 12.0007C21.1673 12.4427 20.9917 12.8666 20.6792 13.1792C20.3666 13.4917 19.9427 13.6673 19.5007 13.6673H19.4257C19.1575 13.6684 18.8955 13.7478 18.6719 13.8959C18.4484 14.044 18.273 14.2542 18.1673 14.5007V14.5007Z'
                  stroke={colors.primary['1']}
                  strokeWidth='1.6'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <defs>
                <clipPath id='clip0_7650_62225'>
                  <rect
                    width='20'
                    height='20'
                    fill='white'
                    transform='translate(2 2)'
                  />
                </clipPath>
              </defs>
            </svg>
          }
          colors={colors}
          darkMode={color === 'dark'}
          onClick={() => onClickMenu('CAMERA_SETTING')}
        >
          {t('Camera Settings')}
        </RenewalWebMenuItem>
      )}

      {/* mantis - 10379, Screen ID C0161기획 내용에 따라 wifi이거나 구모델이 아니면 해당항목 노출되도록 수정(Leehj)*/}
      {/* mantis - 11204, 문구 출력 조건 변경- wifi이거나 신모델, 시그마모델이 아니면 Format microSD card 항목 노출(Leehj) */}
      {/* mantis - 12440, 메뉴 조건 변경- wifi이면서 Format microSD card 지원모델이면 해당 항목 노출(Leehj) */}

      {camera && !_.includes(ENABLED_CLOUD_OLD_MODELS, camera.model) && (
        <RenewalWebMenuItem
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4 10V12.3336C4 12.422 4.03514 12.5069 4.0977 12.5694C4.16026 12.632 4.2451 12.6671 4.33357 12.6671H5.25H6V13.4171V13.8621L4.09786 15.7643C4.06684 15.7952 4.04223 15.8319 4.02544 15.8724C4.00865 15.9128 4 15.9562 4 16M4 10L4.33286 10H4.33359L4.75 10M4 10C4 9.9562 4.00865 9.91284 4.02544 9.87239C4.04223 9.83194 4.06684 9.79521 4.09786 9.76429L6 7.86214V3.66643M4 10H4.33282H4.33284H4.33357H4.75V10M4.75 10C4.75 10.0549 4.73917 10.1093 4.71812 10.16C4.69722 10.2103 4.66666 10.256 4.62819 10.2946L4.75 10.1728M4.75 10V10.1728M4.75 10.1728V11.9171M4.75 10.1728L6.53033 8.39247C6.67098 8.25182 6.75 8.06105 6.75 7.86214V3.66706M4.75 11.9171H4.33357C4.44401 11.9171 4.54993 11.961 4.62803 12.0391C4.70613 12.1172 4.75 12.2231 4.75 12.3336V11.9171ZM4.75 11.9171H6C6.41421 11.9171 6.75 12.2529 6.75 12.6671V13.8621C6.75 14.0611 6.67098 14.2518 6.53033 14.3925L4.75 16.1728M4.75 16.1728V16M4.75 16.1728L4.62819 16.2946C4.66666 16.256 4.69722 16.2103 4.71812 16.16C4.73917 16.1093 4.75 16.0549 4.75 16M4.75 16.1728V20.333M4.75 16V16H4.33357H4.33284H4.33281H4M4.75 16L4.33359 16L4.33286 16L4 16M4 16V20.3336M4 20.3336L4.75 20.3326C4.75 20.3327 4.75 20.3329 4.75 20.333M4 20.3336C4.00057 20.7754 4.17632 21.1989 4.48871 21.5113C4.8011 21.8237 5.22464 21.9994 5.66643 22M4 20.3336H4.75V20.333M4.75 20.333C4.75042 20.5761 4.84716 20.8091 5.01904 20.981C5.19102 21.1529 5.42418 21.2497 5.66739 21.25M5.66643 22V21.25H5.66739M5.66643 22H18.3336M5.66643 22L5.66739 21.25M5.66739 21.25H18.3326M18.3336 22L18.3326 21.25M18.3336 22C18.7754 21.9994 19.1989 21.8237 19.5113 21.5113C19.8237 21.1989 19.9994 20.7754 20 20.3336M18.3336 22V21.25H18.3326M18.3326 21.25C18.5758 21.2497 18.809 21.1529 18.981 20.981C19.1528 20.8091 19.2495 20.5762 19.25 20.3332V20.3336H20M20 20.3336L19.25 20.3326V3.66739L20 3.66643M20 20.3336V3.66643M20 3.66643C19.9994 3.22464 19.8237 2.80111 19.5113 2.48871C19.1989 2.17632 18.7754 2.00057 18.3336 2M20 3.66643H19.25V3.6668C19.2495 3.4238 19.1528 3.19088 18.981 3.01904C18.8091 2.84716 18.5761 2.75042 18.333 2.75M18.3336 2H7.66643M18.3336 2L18.3326 2.75C18.3327 2.75 18.3329 2.75 18.333 2.75M18.3336 2V2.75H18.333M7.66643 2C7.22464 2.00057 6.8011 2.17632 6.48871 2.48871C6.17632 2.80111 6.00057 3.22464 6 3.66643M7.66643 2V2.75H7.66699M7.66643 2L7.66739 2.75C7.66726 2.75 7.66713 2.75 7.66699 2.75M6 3.66643H6.75V3.66706M6 3.66643L6.75 3.66739C6.75 3.66728 6.75 3.66717 6.75 3.66706M6.75 3.66706C6.7504 3.42397 6.84714 3.19094 7.01904 3.01904C7.19092 2.84716 7.42393 2.75042 7.66699 2.75M7.66699 2.75H18.333'
                stroke={colors.primary['1']}
                strokeWidth='1'
                strokeLinecap='round'
              />
              <path
                d='M10 5L10 8'
                stroke={colors.primary['1']}
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M12 5L12 8'
                stroke={colors.primary['1']}
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M14 5L14 8'
                stroke={colors.primary['1']}
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M16 5L16 8'
                stroke={colors.primary['1']}
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M13.1429 11C11.0129 11 9.28571 12.7911 9.28571 15H8L9.69714 16.7911L11.4286 15H10.1429C10.1429 13.28 11.4843 11.8889 13.1429 11.8889C14.8014 11.8889 16.1429 13.28 16.1429 15C16.1429 16.72 14.8014 18.1111 13.1429 18.1111C12.4766 18.1111 11.8605 17.8833 11.3637 17.4998C11.1672 17.348 10.8822 17.3444 10.7098 17.5232C10.5465 17.6926 10.5449 17.963 10.7253 18.1141C11.3864 18.6679 12.225 19 13.1429 19C15.2729 19 17 17.2089 17 15C17 12.7911 15.2729 11 13.1429 11Z'
                fill={colors.primary['1']}
              />
            </svg>
          }
          colors={colors}
          darkMode={color === 'dark'}
          onClick={() => onClickMenu('FORMAT_SD_CARD')}
        >
          {t('Format MicroSD Card')}
        </RenewalWebMenuItem>
      )}

      {/* mantis - 10379, Screen ID C0161기획 내용에 따라 wifi이거나 구모델이 아니면 해당항목 노출되도록 수정(Leehj)*/}
      {/* mantis - 11204, wifi이거나 신모델이거나 시그마모델이면 (구모델이 아니면) 문구 출력 (Leehj) */}
      {/* {connectionSettingsOption && (
        <RenewalWebMenuItem disabled startIcon={<CloudSync />}>
          {t("Cloud connection settings")}
        </RenewalWebMenuItem>
      )} */}

      {fotaCamPerm && (
        <RenewalWebMenuItem
          startIcon={
            color === 'light' ? (
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M5 7H19C20.6569 7 22 8.34315 22 10V14C22 15.6569 20.6569 17 19 17H5C3.34314 17 2 15.6569 2 14V10C2 8.34315 3.34314 7 5 7Z'
                  stroke='#13131C'
                  strokeWidth='1.6'
                />
                <path
                  d='M15.05 13.9C13.973 13.9 13.1 13.027 13.1 11.95C13.1 10.873 13.973 10 15.05 10C16.127 10 17 10.873 17 11.95C17 13.027 16.127 13.9 15.05 13.9Z'
                  stroke='#13131C'
                  strokeWidth='2'
                />
                <path
                  d='M4 4L8 4'
                  stroke='#13131C'
                  strokeWidth='2'
                  strokeLinecap='round'
                />
                <circle
                  cx='4.16667'
                  cy='4.16667'
                  r='4.16667'
                  transform='matrix(-1 0 0 1 11 13)'
                  fill='white'
                />
                <path
                  d='M7 12C7.98891 12 8.95561 12.2933 9.77785 12.8427C10.6001 13.3921 11.241 14.173 11.6194 15.0866C11.9978 16.0002 12.0969 17.0056 11.9039 17.9755C11.711 18.9454 11.2348 19.8363 10.5355 20.5355C9.83627 21.2348 8.94536 21.711 7.97545 21.9039C7.00555 22.0969 6.00022 21.9978 5.08659 21.6194C4.17296 21.241 3.39207 20.6001 2.84266 19.7779C2.29325 18.9556 2.00001 17.9889 2.00001 17C1.99872 16.343 2.12717 15.6923 2.37799 15.0851C2.62881 14.4779 2.99706 13.9262 3.4616 13.4616C3.92615 12.9971 4.47786 12.6288 5.08507 12.378C5.69228 12.1272 6.34303 11.9987 7 12ZM10.992 17.3419C11.1185 17.2161 11.0295 17 10.851 17H10.1543C10.1543 16.1634 9.82197 15.3611 9.23043 14.7696C8.63888 14.178 7.83657 13.8457 7 13.8457C6.59842 13.8428 6.20216 13.919 5.83322 14.068C5.5572 14.1794 5.51899 14.5327 5.72947 14.7431C5.82822 14.8419 5.97983 14.8607 6.10817 14.8056C6.38903 14.6851 6.69269 14.6239 7 14.627C7.62768 14.6295 8.22877 14.8807 8.67169 15.3255C9.11461 15.7702 9.36329 16.3723 9.36328 17H8.66449C8.4863 17 8.39707 17.2154 8.52306 17.3414L9.61292 18.4313C9.69086 18.5092 9.81715 18.5094 9.89533 18.4317L10.992 17.3419ZM3.84571 17C3.85599 17.8298 4.19284 18.6221 4.78328 19.2052C5.37371 19.7883 6.17016 20.1153 7 20.1152C7.39508 20.1177 7.7855 20.0466 8.15181 19.9072C8.41289 19.8079 8.45227 19.475 8.25119 19.2811C8.16313 19.1962 8.03104 19.1792 7.91841 19.2269C7.62859 19.3498 7.31621 19.4131 7 19.4121C6.6855 19.4122 6.37415 19.3495 6.08419 19.2277C5.79424 19.1059 5.53151 18.9274 5.31141 18.7027C5.09131 18.4781 4.91826 18.2118 4.80241 17.9194C4.68656 17.627 4.63023 17.3144 4.63673 17H5.33552C5.5137 17 5.60294 16.7846 5.47694 16.6586L4.37819 15.5598C4.29992 15.4816 4.17295 15.4818 4.09491 15.5603L3.00295 16.659C2.87756 16.7852 2.96693 17 3.14481 17H3.84571Z'
                  fill='#13131C'
                />
              </svg>
            ) : (
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M5 7H19C20.6569 7 22 8.34315 22 10V14C22 15.6569 20.6569 17 19 17H5C3.34314 17 2 15.6569 2 14V10C2 8.34315 3.34314 7 5 7Z'
                  stroke='#EEEEF3'
                  strokeWidth='1.6'
                />
                <path
                  d='M15.05 13.9C13.973 13.9 13.1 13.027 13.1 11.95C13.1 10.873 13.973 10 15.05 10C16.127 10 17 10.873 17 11.95C17 13.027 16.127 13.9 15.05 13.9Z'
                  stroke='#EEEEF3'
                  strokeWidth='2'
                />
                <path
                  d='M4 4L8 4'
                  stroke='#EEEEF3'
                  strokeWidth='2'
                  strokeLinecap='round'
                />
                <circle
                  cx='4.16667'
                  cy='4.16667'
                  r='4.16667'
                  transform='matrix(-1 0 0 1 11 13)'
                  fill='#121216'
                />
                <path
                  d='M7 12C7.98891 12 8.95561 12.2933 9.77785 12.8427C10.6001 13.3921 11.241 14.173 11.6194 15.0866C11.9978 16.0002 12.0969 17.0056 11.9039 17.9755C11.711 18.9454 11.2348 19.8363 10.5355 20.5355C9.83627 21.2348 8.94536 21.711 7.97545 21.9039C7.00555 22.0969 6.00022 21.9978 5.08659 21.6194C4.17296 21.241 3.39207 20.6001 2.84266 19.7779C2.29325 18.9556 2.00001 17.9889 2.00001 17C1.99872 16.343 2.12717 15.6923 2.37799 15.0851C2.62881 14.4779 2.99706 13.9262 3.4616 13.4616C3.92615 12.9971 4.47786 12.6288 5.08507 12.378C5.69228 12.1272 6.34303 11.9987 7 12ZM10.992 17.3419C11.1185 17.2161 11.0295 17 10.851 17H10.1543C10.1543 16.1634 9.82197 15.3611 9.23043 14.7696C8.63888 14.178 7.83657 13.8457 7 13.8457C6.59842 13.8428 6.20216 13.919 5.83322 14.068C5.5572 14.1794 5.51899 14.5327 5.72947 14.7431C5.82822 14.8419 5.97983 14.8607 6.10817 14.8056C6.38903 14.6851 6.69269 14.6239 7 14.627C7.62768 14.6295 8.22877 14.8807 8.67169 15.3255C9.11461 15.7702 9.36329 16.3723 9.36328 17H8.66449C8.4863 17 8.39707 17.2154 8.52306 17.3414L9.61292 18.4313C9.69086 18.5092 9.81715 18.5094 9.89533 18.4317L10.992 17.3419ZM3.84571 17C3.85599 17.8298 4.19284 18.6221 4.78328 19.2052C5.37371 19.7883 6.17016 20.1153 7 20.1152C7.39508 20.1177 7.7855 20.0466 8.15181 19.9072C8.41289 19.8079 8.45227 19.475 8.25119 19.2811C8.16313 19.1962 8.03104 19.1792 7.91841 19.2269C7.62859 19.3498 7.31621 19.4131 7 19.4121C6.6855 19.4122 6.37415 19.3495 6.08419 19.2277C5.79424 19.1059 5.53151 18.9274 5.31141 18.7027C5.09131 18.4781 4.91826 18.2118 4.80241 17.9194C4.68656 17.627 4.63023 17.3144 4.63673 17H5.33552C5.5137 17 5.60294 16.7846 5.47694 16.6586L4.37819 15.5598C4.29992 15.4816 4.17295 15.4818 4.09491 15.5603L3.00295 16.659C2.87756 16.7852 2.96693 17 3.14481 17H3.84571Z'
                  fill='#EEEEF3'
                />
              </svg>
            )
          }
          endIcon={
            newFw ? (
              <div className={classes.newDiv}>
                <Typography
                  category='Default'
                  variant='Caption'
                  htmlColor={colors.primary['0']}
                >
                  NEW
                </Typography>
              </div>
            ) : undefined
          }
          colors={colors}
          darkMode={color === 'dark'}
          onClick={() => onClickMenu('REMOTE_FIRMWARE_UPDATE')}
        >
          {t('Remote Firmware Update')}
        </RenewalWebMenuItem>
      )}
      {rebootCamPerm && (
        <RenewalWebMenuItem
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M17.6719 6.32812L20.0156 3.98438V11.0156H12.9844L16.2188 7.78125C15.0312 6.59375 13.625 6 12 6C10.3438 6 8.92188 6.59375 7.73438 7.78125C6.57812 8.9375 6 10.3438 6 12C6 13.6562 6.57812 15.0781 7.73438 16.2656C8.92188 17.4219 10.3438 18 12 18C13.1562 18 14.2812 17.6094 15.375 16.8281C16.5 16.0469 17.2656 15.1094 17.6719 14.0156H19.7344C19.2969 15.7656 18.3594 17.2031 16.9219 18.3281C15.4844 19.4531 13.8438 20.0156 12 20.0156C9.8125 20.0156 7.9375 19.2344 6.375 17.6719C4.8125 16.1094 4.03125 14.2188 4.03125 12C4.03125 9.78125 4.8125 7.89062 6.375 6.32812C7.9375 4.76563 9.8125 3.98438 12 3.98438C12.9375 3.98438 13.9531 4.21875 15.0469 4.6875C16.1719 5.125 17.0469 5.67188 17.6719 6.32812Z'
                fill={colors.primary['1']}
              />
            </svg>
          }
          onClick={() => onClickMenu('REBOOT_CAMERA')}
          colors={colors}
          darkMode={color === 'dark'}
        >
          {t('Reboot Camera')}
        </RenewalWebMenuItem>
      )}

      {camera?.battery && (
        <RenewalWebMenuItem
          onClick={() => onClickMenu('UNPAIR_BATTERY')}
          startIcon={<UnregisterBattery />}
          colors={colors}
        >
          {t('Unpair Battery')}
        </RenewalWebMenuItem>
      )}

      <div style={{ borderTop: `1px solid ${colors.primary['6']}` }} />
      {deleteCamPerm && camera?.reg_category === 'wifi' ? (
        <RenewalWebMenuItem
          className={classes.delete}
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M10.5 9.75C10.0853 9.75 9.75 10.0853 9.75 10.5V16.5C9.75 16.9148 10.0853 17.25 10.5 17.25C10.9147 17.25 11.25 16.9148 11.25 16.5V10.5C11.25 10.0853 10.9147 9.75 10.5 9.75Z'
                fill='#D81A26'
              />
              <path
                d='M13.5 9.75C13.0853 9.75 12.75 10.0853 12.75 10.5V16.5C12.75 16.9148 13.0853 17.25 13.5 17.25C13.9147 17.25 14.25 16.9148 14.25 16.5V10.5C14.25 10.0853 13.9147 9.75 13.5 9.75Z'
                fill='#D81A26'
              />
              <path
                d='M14.25 2.25H9.75C8.92275 2.25 8.25 2.92275 8.25 3.75V5.25H6H3.75C3.33525 5.25 3 5.58525 3 6C3 6.41475 3.33525 6.75 3.75 6.75H5.25V19.5C5.25 20.7405 6.2595 21.75 7.5 21.75H16.5C17.7405 21.75 18.75 20.7405 18.75 19.5V6.75H20.25C20.6647 6.75 21 6.41475 21 6C21 5.58525 20.6647 5.25 20.25 5.25H18H15.75V3.75C15.75 2.92275 15.0772 2.25 14.25 2.25ZM17.25 19.5C17.25 19.914 16.914 20.25 16.5 20.25H7.5C7.086 20.25 6.75 19.914 6.75 19.5V6.75H17.25V19.5ZM9.75 5.25V3.75H14.25V5.25H9.75Z'
                fill='#D81A26'
              />
            </svg>
          }
          onClick={() => onClickMenu('DELETE_CAMERA')}
          colors={colors}
          darkMode={color === 'dark'}
        >
          {t('Delete Camera')}
        </RenewalWebMenuItem>
      ) : (
        <RenewalWebMenuItem
          className={classes.delete}
          startIcon={
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z'
                stroke='#D81A26'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M8 12H16'
                stroke='#D81A26'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          }
          onClick={() => onClickMenu('DELETE_CAMERA')}
          colors={colors}
          darkMode={color === 'dark'}
        >
          {t('Deactivate Cloud')}
        </RenewalWebMenuItem>
      )}
    </RenewalMobileMenu>
  );
};
